<template>
	<div class="amap-page-container">

		<el-amap vid="amapDemo" :center="center" :zoom="zoom" class="amap-demo" :events="events" pitch-enable="false">
			<el-amap-marker v-for="(marker,index) in markers" :key="index" :events="marker.events" :icon="marker.icon" :position="marker.position" />
			<el-amap-info-window v-if="window" :position="window.position" :visible="window.visible" :content="window.content"
			 :offset="window.offset" :close-when-click-map="true" :is-custom="true">
				<div id="info-window">
					<p>长发中心办公室</p>

				</div>
			</el-amap-info-window>
		</el-amap>
	</div>
</template>

<script>
	export default {
		name: 'AmapPage',
		data: function() {
			const self = this
			return {
				data: [{

					position: '118.79718,32.040299',
					address: '另一个地址'

				}, ],
				zoom: 18,
				center: [118.79718, 32.040299],
				expandZoomRange: true,
				markers: [],
				windows: [],
				window: '',
				events: {
					click(e) {
						const {
							lng,
							lat
						} = e.lnglat
						self.lng = lng
						self.lat = lat
					}
				},
				lng: 0,
				lat: 0
			}
		},
		mounted() {
			this.point()
		},
		methods: {
			point() {
				var that = this;
				that.$axios({
					method: "get",
					url: "webpc/pcmastercompany/list",
					// data: this.$qs.stringify(data)
					params: {
						// location:0
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if (res.data.result == 200) {
						var data = res.data.detail;
						that.center = [data.cox,data.coy];
						const markers = [];
						const windows = [];
						this.data.forEach((item, index) => {
							markers.push({
								position: [data.cox,data.coy],
						
								icon: require('@/assets/home/坐标定位.svg'), //不设置默认蓝色水滴
								events: {
									mouseover() {
										// 方法：鼠标移动到点标记上，显示相应窗体
										that.windows.forEach(window => {
											window.visible = false // 关闭窗体
										})
										that.window = that.windows[index]
										that.$nextTick(() => {
											that.window.visible = true
										})
									}
								}
							})
							windows.push({
								position: [data.cox,data.coy],
								isCustom: true,
								offset: [10, 5], // 窗体偏移
								showShadow: true,
								visible: true, // 初始是否显示
								address: data.address
							})
						})
						//  加点
						this.markers = markers
						// 加弹窗
						this.windows = windows
					}
				
				})
				
			},
			checkDetail() {
				alert('点击了查看详情')
			}
		}

	}
</script>

<style lang="scss" scoped>
	.amap-icon {
		.amap-container img {
			max-width: 25px !important;
		}
	}

	.amap-page-container {
		position: relative;
		height: 100%;
	}

	#info-window {
		width: 120px;
		height: 56px;
		margin-left: 30px;
		background: rgba(255, 255, 255, 0.9);
		border-radius: 4px;
		position: relative;
		overflow: hidden;

		.detail {
			width: 100%;
			height: 24px;
			color: #fff;
			background-color: #1a73e8;
			position: absolute;
			bottom: 0;
			font-size: 12px;
			line-height: 24px;
			text-align: center;
			cursor: pointer;
		}
	}
</style>
